<eda-dialog2 width="65vw" height="65vh" (apply)="saveRelation()" (close)="closeDialog()" [header]="title" >
  <div content class="py-6">
    <form [formGroup]="form">
      <div class="grid grid-cols-4 gap-4">
        <p-dropdown [options]="targetTables" formControlName="targetTable" filter="true" optionLabel="label"
          i18n-placeholder="@@placeholderTargetTables" placeholder="Tabla destino"
          id="eda_add_relation_targetTable" [style]="{'width': '100%'}" [emptyMessage]="emptyMessageTags">
        </p-dropdown>

        <p-dropdown [options]="sourceCols" formControlName="sourceCol" filter="true"
          optionLabel="display_name.default" i18n-placeholder="@@placeholderSourceColumns"
          placeholder="Columna origen" (onChange)="getColumnsByTable()" id="eda_add_relation_sourceCols" [style]="{'width': '100%'}" [emptyMessage]="emptyMessageTags">
        </p-dropdown>

        <p-dropdown [options]="targetCols" formControlName="targetCol" filter="true"
          i18n-placeholder="@@placeholderTargetColumns" placeholder="Columna destino "
          id="eda_add_relation_targetCol" [style]="{'width': '100%'}" [emptyMessage]="emptyMessageTags">
        </p-dropdown>

        <span class="p-float-label h-[3.2rem] w-full">
          <input
            id="eda_add_relation_relationName"
            formControlName="display_name"
            class="w-full h-full rounded-md border border-gray-300 px-3 py-2"
            pInputText
          />
          <label i18n="@@placeholderRelationName">Nombre relación</label>
        </span>

      </div>

      <button class="execute-button mt-4" (click)="addRelation()"
        [disabled]="!form.controls.targetTable.value  ||  !form.value.sourceCol || !form.value.targetCol ">
        <span i18n="@@addRelation">Añadir relación</span>
      </button>

      <div class="mt-4">
        <ul>
          @for(sourceCol of selectedSourceCols; track $index){
            <li>
              <i class="fa fa-close" style="color: #c0555e;"
                (click)="deleteRelation($index)">
              </i>
              &nbsp;&nbsp;
              {{controller.params.table.description}}.{{sourceCol.display_name.default}} ⇴
              {{targetTable}}.{{selectedTargetCols[$index].display_name.default}}
            </li>
          }
        </ul>
      </div>
    </form>
  </div>
</eda-dialog2>